import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"

const FilterForm = ({
    closePopup,
    dropdownData,
    filterForm,
    setFilterForm,
    filterCount,
    setFilterCount,
    applyFilterHandler
}) => {

    const resetFilterForm = () => {
        setFilterCount(0);
        setFilterForm({});
        applyFilterHandler();
        closePopup();
    };


    const { allBanks, thirdPartyPaymentMode } = dropdownData;

    const handleApplyFilter = () => {
        let fCount = getFilterCount({ ...filterForm });
        setFilterCount(fCount);
        applyFilterHandler(0, filterForm);
        closePopup();
    };

    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
    };

    return (
        <Card
            className="mb-0 regular-body label-color"
            style={{ width: "330px", borderRadius: "12px" }}
        >
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="regular-large-bold">Filters</div>
                </div>

                <div className="d-flex flex-column gap-md">
                    <AAutoComplete
                        label="Third party code"
                        currentValue={filterForm?.thirdPartyCodes}
                        items={thirdPartyPaymentMode}
                        handleChange={(value) => {
                            filterFormHandler("thirdPartyCodes", value);
                        }}
                        selectAllMenuButton={true}
                        isShowCount={true}
                        isMulti={true}
                    />

                    <AAutoComplete
                        label="Bank"
                        currentValue={filterForm?.banks}
                        items={allBanks}
                        handleChange={(value) => {
                            filterFormHandler("banks", value);
                        }}
                        selectAllMenuButton={true}
                        isShowCount={true}
                        isMulti={true}
                    />

                </div>
                <div className="mt-3 d-flex flex-row-reverse justify-content-between ">
                    <AButton
                        variant="primary_filled"
                        className="button_remove_left_margin"
                        onClick={() => {
                            handleApplyFilter();
                        }}
                        disabled={getFilterCount({ ...filterForm }) == 0}
                    >
                        Apply filter
                    </AButton>

                    {filterCount > 0 && (
                        <AButton
                            variant="outline"
                            className="button_remove_left_margin"
                            updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                            onClick={resetFilterForm}
                        >
                            Remove filter
                        </AButton>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default FilterForm;